export const supportedLanguages = [
  { code: 'en', name: 'English' },
  { code: 'lv_LV', name: 'Latviešu' },
];

export const getIntlLocale = (language?: string): string => {
  const normalizedLanguage = (language ?? 'en').replace(/_/g, '-');

  try {
    return Intl.getCanonicalLocales(normalizedLanguage)[0] ?? 'en';
  } catch {
    return 'en';
  }
};

/**
 * Clamp a stored language to one the app can actually render.
 *
 * `user_settings.preferred_language` is a database enum with eight values
 * while the UI ships two, and the column is nullable despite having a
 * default. Both cases reach i18next as something it has no bundle for.
 */
export const toSupportedLanguage = (
  language: string | null | undefined
): string =>
  supportedLanguages.some(entry => entry.code === language)
    ? (language as string)
    : supportedLanguages[0].code;
